import Reveal from '../components/animation/Reveal';
import PageFrame from '../components/layout/PageFrame';
import { businessDetails } from '../data/siteContent';

function AboutPage() {
  return (
    <PageFrame title="About Us" eyebrow="Our studio">
      <Reveal className="split-content">
        <div>
          <h2>Saqar Al-Jazeera is built around precise dishdasha tailoring and respectful service.</h2>
          <p>
            Based in {businessDetails.address}, we focus on special tailoring for men's dishdasha with practical fabric guidance, careful measurements, and clean finishing.
          </p>
          <p>
            Our aim is simple: make every customer feel confident in clothing that is measured well, stitched cleanly, and delivered with care.
          </p>
        </div>
        <div className="process-list">
          <Reveal delay={0.05}><strong>Measured fit</strong><span>Clear sizing notes for consistent outcomes.</span></Reveal>
          <Reveal delay={0.12}><strong>Premium finish</strong><span>Neat seams, buttons, collars, cuffs, and hems.</span></Reveal>
          <Reveal delay={0.19}><strong>Branches</strong><span>{businessDetails.branches.map((branch) => branch.name).join(' and ')}.</span></Reveal>
        </div>
      </Reveal>
    </PageFrame>
  );
}

export default AboutPage;
